module.exports = __webpack_public_path__ + "static/media/Pricetag.23a4a936.svg";